import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  const { authData } = useAuth();

  // Determine Home URL based on role
  const role = authData?.role?.toLowerCase();
  const homeUrl = role === 'systemadmin' ? '/admin/dashboard' : '/hotels/dashboard';

  // Split the current pathname into segments
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Custom mapping for specific segments
  const customSegments = {
    'hotels': {
      url: '/hotels/hotelprofilepage',
      label: 'Hotels'
    }
  };

  // Build breadcrumb trail with custom handling
  const breadcrumbs = pathSegments.map((segment, idx) => {
    // Use custom mapping if available, otherwise generate default
    if (customSegments[segment] && idx === 1) { // Only apply to first "hotels" segment
      return customSegments[segment];
    }
    
    const url = `/${pathSegments.slice(0, idx + 1).join('/')}`;
    const label = segment
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());

    return { label, url };
  });

  // Start with Home, then add other segments
  const fullCrumbs = [{ label: 'Home', url: homeUrl }, ...breadcrumbs];

  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      {fullCrumbs.map((crumb, idx) => (
        <span key={idx}>
          {idx < fullCrumbs.length - 1 ? (
            <Link to={crumb.url}>{crumb.label}</Link>
          ) : (
            <span>{crumb.label}</span>
          )}
          {idx < fullCrumbs.length - 1 && ' / '}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb;